import { HARVEST_PHASES } from '../constants/phases.constants';
import { NUTRIENTS } from '../constants/nutrients.constants';
import type { DynamicParcelEntry } from '../types';

export const createEmptyDynamicParcel = (): DynamicParcelEntry[] =>
	HARVEST_PHASES.map((phase) => ({
		phase,
		weeks: Number.NaN,
		...Object.fromEntries(NUTRIENTS.map((nutrient) => [nutrient, Number.NaN])),
	}) as DynamicParcelEntry);

export const createSimulatedDynamicParcel = (): DynamicParcelEntry[] => {
	const entries = createEmptyDynamicParcel().map((entry, index) => ({
		...entry,
		weeks: Math.floor(52 / HARVEST_PHASES.length) + (index < 52 % HARVEST_PHASES.length ? 1 : 0),
	}));
	NUTRIENTS.forEach((nutrient) => {
		const weights = entries.map(() => Math.random() + 0.1);
		const total = weights.reduce((sum, weight) => sum + weight, 0);
		const tenths = weights.map((weight) => Math.floor(weight / total * 1000));
		const remainder = 1000 - tenths.reduce((sum, value) => sum + value, 0);
		entries.forEach((entry, index) => {
			entry[nutrient] = (tenths[index] + (index < remainder ? 1 : 0)) / 10;
		});
	});
	return entries;
};
